import React from 'react';
import firebase from '../../../config/firebaseConfig';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { isLoaded } from 'react-redux-firebase';
import { ADMIN_LIST } from '../../../config/adminConfig';
import { signOut } from '../../../actions/authActions';
import { NavLink, useNavigate } from 'react-router-dom';
import { Nav, Modal, Button} from 'react-bootstrap';
import DarkThemeSwitcher from '../DarkThemeSwitcher';
import Player from '../../player/Player';

function NavItems({ theme, setTheme, editLocalStorageTheme }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentUser } = useAuth();
  // const [expanded, setExpanded] = useState(false);
  const [showPlayerModal, setShowPlayerModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Récupération de l'état de connexion globale
  const uid = useSelector((state) => state.firebase.auth.uid);

  // 👑 CORRECTION 1 : Récupération du rôle en direct depuis le profil utilisateur Redux-Firebase
  const profile = useSelector((state) => state.firebase.profile);

  const handleConfirmLogout = async () => {
    setShowLogoutModal(false); // Ferme la modale
    dispatch(signOut());

    try {
      await firebase.auth().signOut();
      navigate('/connexion');
    } catch (err) {
      console.error("Erreur de déconnexion :", err);
    }
  };

   const changeTheme = (newTheme) => {
    if (typeof setTheme === 'function') {
      setTheme(newTheme);
      editLocalStorageTheme(newTheme);
    } else {
      console.error("setTheme n'est pas reconnu comme une fonction !", setTheme);
    }
  };

  const darkThemeSwitcherHandleClick = () => {
    const newTheme = {
      ...theme,
      darkTheme: !theme?.darkTheme
    };
    changeTheme(newTheme);
  };
  
  const userRole = (isLoaded(profile) && profile) ? (profile.role || 'membre') : 'membre';

  return (
    <Nav className="ms-auto gap-2 align-items-lg-center">

      {uid ? (
        <React.Fragment>
          <Nav.Link eventKey="1" as={NavLink} to='/' className='nav-link d-flex align-items-center' title='Accueil'>
            <i className='material-icons me-1'>home</i> <span className="d-lg-none">Accueil</span>
          </Nav.Link>

          <Nav.Link eventKey="2" as={NavLink} to='/actions' className='nav-link d-flex align-items-center' title='Mes actions'>
            <i className='material-icons me-1'>archive</i> <span className="d-lg-none">Mes actions</span>
          </Nav.Link>

          <Nav.Link eventKey="3" as={NavLink} to='/utilisateur/dashboard' className='nav-link d-flex align-items-center' title='Mon tableau de bord'>
            <i className='material-icons me-1'>apps</i> <span className="d-lg-none">Tableau de bord</span>
          </Nav.Link>

          {(ADMIN_LIST.includes(uid) || userRole === 'admin') && (
            <Nav.Link eventKey="4" as={NavLink} to="/admin" className="nav-link d-flex align-items-center" title='Administration'>
              <i className='material-icons me-1'>account_box</i> <span className="d-lg-none">Admin</span>
            </Nav.Link>
          )}
           {currentUser && (
             <React.Fragment>
                  <div className="d-flex align-items-center"
                    // onClick={() => {
                    //   setExpanded(false);
                    // }}
                  >
                    <DarkThemeSwitcher theme={theme || { darkTheme: false }} handleClick={darkThemeSwitcherHandleClick}/>
                  </div>

                  <div 
                    className="nav-link d-flex align-items-center" 
                    onClick={() => {
                      // setExpanded(false);
                      setShowPlayerModal(true);
                    }}
                    style={{ cursor: 'pointer', fontSize: '1.9rem' }}
                    title="Ouvrir le lecteur"
                    >
                      <i className="material-icons me-1">headset</i>  
                  </div>
                </React.Fragment>
              )}
          <Nav.Link className='nav-link d-flex align-items-center text-danger' onClick={() => setShowLogoutModal(true)} title='Se déconnecter'>
            <i className='material-icons'>logout</i> <span className="d-lg-none">Déconnexion</span>
          </Nav.Link>
        </React.Fragment>
        ) : (
          <React.Fragment>
            <Nav.Link as={NavLink} to='/' className='nav-link'>
              Accueil
                </Nav.Link>
            <Nav.Link as={NavLink} to='/connexion' className='nav-link'>
              Connexion
                </Nav.Link>
            <Nav.Link as={NavLink} to='/inscription' className='nav-link'>
              Inscription
                </Nav.Link>
          </React.Fragment>
        )}

      {/* 🎵 Modale Lecteur Audio */}
      <Modal
        show={showPlayerModal}
        onHide={() => setShowPlayerModal(false)}
        centered
        size="sm"
        contentClassName="bg-light text-dark border-secondary shadow-lg"
        >
        <Modal.Header closeButton closeVariant="dark" className="border-secondary py-2">
          <Modal.Title className="fs-6 m-0 d-flex align-items-center gap-2">
            <span>🎵</span> Lecteur Audio
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 text-center">
          <Player />
        </Modal.Body>
        <Modal.Footer className="border-secondary border-opacity-25 pt-1 justify-content-center">
          <Button variant="outline-dark" size="sm" className="w-100 fw-semibold" onClick={() => setShowPlayerModal(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

       {/* 🟢 ÉTAPE 3 : Modale d'avertissement de Déconnexion */}
      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        contentClassName="bg-light text-dark border-secondary shadow-lg"
      >
            <Modal.Header closeButton closeVariant="dark" className="text-danger border-secondary py-2">
          <Modal.Title className="m-0 text-danger fw-semibold" style={{ fontSize: '1.2rem' }}>
            Attention
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center fw-semibold p-2" style={{ fontSize: '1.1rem' }}>
          Vous allez vous déconnecter...
        </Modal.Body>
            <Modal.Footer className="d-flex justify-content-end border-top-0 pt-3">
          <Button variant="secondary" className="px-3 fw-semibold" onClick={() => setShowLogoutModal(false)}>
            Annuler
          </Button>
          <Button variant="danger" className="px-3 fw-semibold" onClick={handleConfirmLogout}>
            Se déconnecter
          </Button>
        </Modal.Footer>
      </Modal>
    </Nav>
  );
}

export default NavItems;